export const APP_NAME = 'providers-app'
